export default "__VITE_ASSET__C83BYPa9__"